import { inject, InjectionKey, provide } from '@nuxtjs/composition-api'
import { useConfig } from '../useConfig'
import { injectProductList } from './useProductList'
import {
  ListType,
  ProductListOptions,
} from '~/types/product'

export const useProductSpecialNode = () => {
  const base = injectProductList()
  const { ensureConfig } = useConfig()

  const initialize = async () => {
    await ensureConfig()
    interface Filter {
      field: string
      value: string
    }
    const prefilters: Filter[] = [
      {
        field: 'DiscountStatus',
        value: 'Ja',
      }
    ]

    await base.ensureOptions(() => {
      const option: ProductListOptions = {
        listType: ListType.Category,
        prefilters
      }
      return option
    })

    await base.loadProducts(true)
  }

  return {
    ...base,
    initialize,
  }
}

// provide productSpecialNode
export type ProductSpecialNodeProvider = ReturnType<
  typeof useProductSpecialNode
>

const ProductSpecialNodeProviderKey: InjectionKey<ProductSpecialNodeProvider> =
  Symbol('Provider:ProductSpecialNode')

export const provideProductSpecialNode = () => {
  const result = useProductSpecialNode()

  provide(ProductSpecialNodeProviderKey, result)
}

// inject productSpecialNode
export const injectProductSpecialNode = () => {
  const result = inject(ProductSpecialNodeProviderKey)
  if (!result) {
    throw new Error('product specialNode provider not set')
  }

  return result
}
